module.exports = __webpack_public_path__ + "img/email.f2fb4895.svg";